export class NonLoggedUser {
  username: string;
  password: string;
}
